import { DatePipe } from '@angular/common'
import { Component, input, ChangeDetectionStrategy } from '@angular/core'
import { ClientNotification } from '../models/client-notification.model'

@Component({
    selector: 'app-client-notification-card',
    imports: [DatePipe],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './client-notification-card.component.html',
})
export class ClientNotificationCardComponent {
    notif = input.required<ClientNotification>()
}
